import { createError } from './create-error';
export const TopicSubscribeError = createError('TopicSubscribeError', topic => `Failed to subscribe to topic '${topic}'.`, {
  PROXY_UNAVAILABLE: 'Failed to initialize connection.',
  HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
  CONNECTION_UNAVAILABLE: "Connection wasn't opened",
  BROKER_UNAVAILABLE: 'Connection to broker has failed',
  STORAGE_UNAVAILABLE: 'Topic subscription storage is unavailable',
  FAILED_TO_STORE_SUBSCRIPTION: 'Failed to store subscription'
});